import { useCallback, useEffect, useMemo, useState } from 'react';
import affiliationService from '../services/affiliationService';
import {
  findAffiliationByCode,
  findAffiliationById,
  getDefaultAffiliation,
  mapAffiliationsToOptions,
  resolveCompanyAffiliation
} from '../utils/affiliationHelpers';

export function useSmieAffiliations({ activeOnly = true } = {}) {
  const [affiliations, setAffiliations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const res = await affiliationService.list({ activeOnly });
      const rows = res?.data || [];
      setAffiliations(mapAffiliationsToOptions(rows));
    } catch (err) {
      console.error('Chargement affiliations SMIE:', err);
      setError(err.message || 'Impossible de charger les affiliations');
      setAffiliations([]);
    } finally {
      setLoading(false);
    }
  }, [activeOnly]);

  useEffect(() => {
    load();
  }, [load]);

  const defaultAffiliation = useMemo(
    () => getDefaultAffiliation(affiliations),
    [affiliations]
  );

  const resolveForCompany = useCallback(
    (company) => resolveCompanyAffiliation(company, affiliations),
    [affiliations]
  );

  return {
    affiliations,
    loading,
    error,
    reload: load,
    defaultAffiliation,
    findById: (id) => findAffiliationById(affiliations, id),
    findByCode: (code) => findAffiliationByCode(affiliations, code),
    resolveForCompany
  };
}

export default useSmieAffiliations;
